import React, { useEffect, useState } from "react";
import HWCard from "./HomeworkCard";
import { $host } from "../../../../http";

const HWCardList = ({hwId, ...props}) => {
    const [questionsList, setQuestionsList] = useState()
    const getHWQuestions = async () => {
        try {
            const {data} = await $host.get(`/api/students/homeworks/${hwId}/questions`)
            setQuestionsList(data.body)
        } catch (e) {
            console.error(e);
        }
    }
    useEffect(() => {
        getHWQuestions()
    }, [hwId])
    return (
        <div className="flex flex-col gap-4">
            {questionsList && questionsList.map((hw, i) => <HWCard handleDeletion={getHWQuestions} data={hw.question} idx={i} key={i * 100} />)}
        </div>
    )
}

export default HWCardList